export default {
  delimiter: {
    display: 'inline-block',
    width: 16,
  },
};
